import 'ui-core/widgets/slideshow/js/showcase-slideshow';

UX.showcaseSlideshow.init({navigationEvent: 'mouseover'});
